'use client';

import React, { useMemo } from 'react';
import { IconBirthday1 } from '@/features/icons';
import { cn } from '@/utils/cn';
import './style.css';
import { useLanguage } from '../../context/language-context-provider';
import SectionHeading from '../section-heading';
const ProgressDesktop = () => {
  const {
    t,
    language
  } = useLanguage();
  const isEn = language === 'en';
  const ITEMS = useMemo(() => Array.from({
    length: 13
  }, (_, index) => {
    const itemNumber = index + 1;
    return {
      year: t(`progress.item${itemNumber}.year`),
      name: t(`progress.item${itemNumber}.name`)
    };
  }), [t]);
  return <div className='homepage-container mt-34' id='progress-desktop' data-sentry-component="ProgressDesktop" data-sentry-source-file="progress-desktop.tsx">
            <div className='flex flex-col gap-30'>
                <div className='row w-3/4 self-end'>
                    <span className={cn('vertical-line', isEn ? 'right-0' : 'left-0')} />

                    <SectionHeading icon={<IconBirthday1 />} title={t('progress.title')} className={cn('absolute bottom-0 translate-y-1/2', isEn ? 'left-0 -translate-x-full' : 'right-0 translate-x-full')} data-sentry-element="SectionHeading" data-sentry-source-file="progress-desktop.tsx">
                        <span className={cn('absolute bottom-full box-content h-14 w-px bg-border-pink pt-34', isEn ? 'left-20' : 'right-10')} />
                    </SectionHeading>

                    {ITEMS.slice(0, 3).map(({
          name,
          year
        }) => <div className='item' key={name}>
                            <span className='year'>{year}</span>
                            <span>{name}</span>
                        </div>)}
                </div>
                <div className='row flex-row-reverse'>
                    <span className={cn('vertical-line', isEn ? 'left-0' : 'right-0')} />

                    {ITEMS.slice(3, 7).map(({
          name,
          year
        }) => <div className='item' key={name}>
                            <span className='year'>{year}</span>
                            <span>{name}</span>
                        </div>)}
                </div>
                <div className='row'>
                    <span className={cn('vertical-line', isEn ? 'right-0' : 'left-0')} />

                    {ITEMS.slice(7, 11).map(({
          name,
          year
        }) => <div className='item' key={name}>
                            <span className='year'>{year}</span>
                            <span>{name}</span>
                        </div>)}
                </div>
                <div className='row mg:w-3/5 w-2/3 flex-row-reverse !justify-end gap-20 self-end'>
                    {ITEMS.slice(11, 13).map(({
          name,
          year
        }, index) => <div className='item' key={name}>
                            {index === 1 && <span className={cn('absolute -bottom-5.5 h-0.5 w-1/2 bg-white', isEn ? '-left-px' : '-right-px')} />}
                            <span className='year'>{year}</span>
                            <span>{name}</span>
                        </div>)}
                </div>
            </div>
        </div>;
};
export default ProgressDesktop;